<section class="hd-melancholy-cheat-sheet-page">
  <!-- Controls -->
  <e-card2 class="hd-melancholy-cheat-sheet-page__controls-card" padding="2">
    <div class="hd-melancholy-cheat-sheet-page__controls" aria-label="Melancholy cheat sheet controls">
      <e-hd-content-language-picker></e-hd-content-language-picker>

      <span class="hd-melancholy-cheat-sheet-page__divider"></span>

      <button type="button" class="hd-melancholy-cheat-sheet-page__control" (click)="print()" aria-label="Print de cheat sheet">
        <i eIcon icon="print"></i>
        <span>Print</span>
      </button>
    </div>
  </e-card2>

  @if (pageTitle()) {
    <h2 class="hd-melancholy-cheat-sheet-page__title">{{ pageTitle() }}</h2>
  }
  @if (pageSubtitle()) {
    <p class="hd-melancholy-cheat-sheet-page__subtitle">{{ pageSubtitle() }}</p>
  }

  <div class="hd-melancholy-cheat-sheet-page__deck">
    <div class="hd-melancholy-cheat-sheet-page__column hd-melancholy-cheat-sheet-page__column--left">
      @for (gates of leftColumn; track cardKey(gates)) {
        <hd-melancholy-card [gates]="gates" />
      }
    </div>

    <div class="hd-melancholy-cheat-sheet-page__center">
      <img
        class="hd-melancholy-cheat-sheet-page__chart"
        [src]="chartImage"
        [alt]="chartAlt()"
      />

      <div class="melancholy-legend">
        @for (entry of legend(); track entry.key) {
          <div class="melancholy-legend__entry">
            <span class="melancholy-legend__color" [style.background-color]="entry.color"></span>
            <div class="melancholy-legend__text">
              <span class="melancholy-legend__label" [style.color]="entry.color">{{ entry.title }}</span>
              <span class="melancholy-legend__keynote">{{ entry.keynote }}</span>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="hd-melancholy-cheat-sheet-page__column hd-melancholy-cheat-sheet-page__column--right">
      @for (gates of rightColumn; track cardKey(gates)) {
        <hd-melancholy-card [gates]="gates" />
      }
    </div>
  </div>
</section>
